import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import useFormContext from 'dpl/shared/form/hooks/useFormContext';
import LoadingSpinner from 'dpl/components/LoadingSpinner';
import { createLineItems } from 'dpl/components/StripeCharge/New/StripeChargeModal/util';
import StripeChargeModalPaymentSummaryV3 from 'dpl/components/StripeCharge/New/StripeChargeModal/StripeChargeModalPaymentSummaryV3';

export default function Summary({
  paymentRequest,
  breederProfile,
  isLoadingSummary,
  handleChangeTierSelection
}) {
  const { formState } = useFormContext();
  const lineItems = useCallback(() => {
    if (paymentRequest.category) {
      return createLineItems(
        paymentRequest,
        paymentRequest.amount_in_dollars,
        paymentRequest.category,
        breederProfile
      );
    }

    return [];
  }, [paymentRequest]);

  if (isLoadingSummary) {
    return (
      <div className="flex flex-column items-center justify-center tc absolute top-0 right-0 bottom-0 left-0">
        <LoadingSpinner className="loading-spinner--medium" />
        <span className="nt3">Updating...</span>
      </div>
    );
  }

  return (
    <div className="relative" style={{ minHeight: 160 }}>
      <div>
        <h2 className="lh-title f2 mb4 mt8 font-sans">Summary</h2>
        <StripeChargeModalPaymentSummaryV3
          className="ba br12 b--default"
          amountTotal={paymentRequest.total_in_dollars}
          amountSubtotal={formState.amount_in_dollars}
          lineItems={lineItems()}
          paymentTier={formState.payment_tier}
          paymentMethod={formState.payment_method}
          category={formState.category}
          onChangeSelection={handleChangeTierSelection}
        />
      </div>
    </div>
  );
}

Summary.propTypes = {
  paymentRequest: PropTypes.shape({
    total_in_dollars: PropTypes.string,
    amount_in_dollars: PropTypes.string,
    category: PropTypes.string
  }).isRequired,
  breederProfile: PropTypes.shape({}).isRequired,
  isLoadingSummary: PropTypes.bool.isRequired,
  handleChangeTierSelection: PropTypes.func.isRequired
};
